export const contexts = {
  login: 'login',
  orders: 'orders',
  vendors: 'vendors',
  notFound: 'notFound',
  masterList: 'masterlist',
  unauthorized: 'unauthorized',
};

export const contextToPageNameMap = {
  login: 'Login',
  orders: 'Orders',
  vendors: 'Labs',
  notFound: 'Not Found',
  masterList: 'Master List',
  unauthorized: 'Unauthorized',
};

export const pharmacyContexts = {
  orders: 'orders',
  vendors: 'vendors',
};

export const pharmacyContextToPageNameMap = {
  login: 'Login',
  orders: 'Orders',
  vendors: 'Pharmacies',
  notFound: 'Not Found',
  masterList: 'Master List',
  unauthorized: 'Unauthorized',
};
